import { gql } from '@apollo/client';

export const FETCH_MODELLING_SEQUENCE_QUERY = gql`
    query fetchModellingSequences {
        facility {
            configurations {
                sequences {
                    id
                    name
                    isEnabled
                    steps {
                        calmetConfiguration {
                            id
                            name
                        }
                    }
                }
            }
        }
    }
`;
